import { Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { record_type, class_type, obj_type, float64_type, string_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import * as react from "@sentry/react";

export class SentryConfig extends Record {
    constructor(dsn, tracesSampleRate, integrations) {
        super();
        this.dsn = dsn;
        this.tracesSampleRate = tracesSampleRate;
        this.integrations = integrations;
    }
}

export function SentryConfig_$reflection() {
    return record_type("Sentry.SentryConfig", [], SentryConfig, () => [["dsn", string_type], ["tracesSampleRate", float64_type], ["integrations", class_type("System.Collections.Generic.IEnumerable`1", [obj_type])]]);
}

export function init() {
    react.init(new SentryConfig("https://c35434b4e5d04302ab51f0ffed31b706@o990465.ingest.sentry.io/4505367961927680", 0.2, [new react.BrowserTracing({tracePropagationTargets: ['digital.torghatten.no']})]));
}

//# sourceMappingURL=Sentry.js.map
